import { SvgConsumer } from '@components/icons/svgConsumer';
import { alertStyleMap } from '@components/hotSeat/utils';
import { filterDuplicates, sortAlerts } from '../../helpers';
import { JobAlertTooltipProps } from './types';
import { cn } from '@utils/cn';

export const JobAlertTooltip = ({ data, wrap }: JobAlertTooltipProps) => (
  <div className={cn('flex flex-col gap-1', wrap && 'gap-2.5 text-sm')}>
    {filterDuplicates(sortAlerts(data), 'message').map((el) => (
      <div key={el.id} id={el.id} className={cn('flex items-center gap-2', wrap && 'items-start')}>
        <SvgConsumer
          id={['error', 'issue'].includes(el.alertType) ? 'error' : 'warning'}
          className={`${
            alertStyleMap[['error', 'issue'].includes(el.alertType) ? 'error' : 'warning'].icon
          } shrink-0 text-l`}
        />
        <span
          className={cn(
            'overflow-hidden text-ellipsis whitespace-nowrap',
            wrap && 'whitespace-normal',
          )}>
          {el.message}
        </span>
      </div>
    ))}
  </div>
);
